import { connect } from 'react-redux';
import get from 'lodash/get';

import {
  getODNSHistoryCsvDownload,
  resetODNSHistoryCsvDownload
} from '../../../../redux/actions/ns/onDemandScreening';
import HistoryOnDemand from './history.jsx';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    csvData: get(state, 'nsOnDemandScreening.alertHistory.csvData', null),
    historyApiStatus: get(
      state,
      'nsOnDemandScreening.alertHistory.isLoading',
      false
    ),
    hasError: get(state, 'nsOnDemandScreening.alertHistory.hasError', false)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getODNSHistoryCsvDownload: (payload) => {
      dispatch(getODNSHistoryCsvDownload(payload));
    },
    resetODNSHistoryCsvDownload: () => {
      dispatch(resetODNSHistoryCsvDownload());
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(HistoryOnDemand);
